module.exports = __webpack_public_path__ + "img/inconsolata-dark.535ad22b.png";